import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
const testimonials = [{
  name: 'Jenna R.',
  location: 'Lincoln, NE',
  text: "Dr. Martin and his team are wonderful. They take the time to actually explain what's going on, never make you feel rushed, and have been our family's dentist for over a decade. I drive across town just to see them."
}, {
  name: 'Mike & Sarah H.',
  location: 'Waverly, NE',
  text: "We've been bringing all three of our kids here for years. The staff is incredibly patient with the little ones and Dr. Martin is genuinely kind. It honestly feels like visiting family — they really do go the extra smile."
}, {
  name: 'Tom K.',
  location: 'Lincoln, NE',
  text: "Had a tooth emergency right before a work trip and they got me in same-day. Honest about what I actually needed, never pushy, and the cleaning afterwards was the most comfortable I've ever had. Highly recommend."
}];
export function Testimonials() {
  return <section id="testimonials" className="py-24 bg-sage-50 relative overflow-hidden" data-id="element-205">
      {/* Decorative background */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-7xl h-full overflow-hidden pointer-events-none" data-id="element-206">
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-white rounded-full blur-3xl opacity-60" data-id="element-207"></div>
        <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-sage-100 rounded-full blur-3xl opacity-60" data-id="element-208"></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10" data-id="element-209">
        <div className="text-center max-w-2xl mx-auto mb-16" data-id="element-210">
          <h2 className="text-sage font-semibold tracking-wider uppercase text-sm mb-3" data-id="element-211">
            Patient Stories
          </h2>
          <h3 className="text-4xl md:text-5xl font-serif text-charcoal-800 mb-6" data-id="element-212">
            Loved by Lincoln &amp; Waverly families.
          </h3>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-213">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white p-8 rounded-3xl shadow-sm relative" data-id="element-214">
              <Quote className="absolute top-8 right-8 text-sage-100 w-12 h-12 rotate-180" data-id="element-215" />

              <div className="flex items-center gap-1 mb-6" data-id="element-216">
                {[...Array(5)].map((_, i) => <Star key={i} size={18} className="fill-coral text-coral" data-id="element-217" />)}
              </div>

              <p className="text-charcoal-600 leading-relaxed mb-8 relative z-10" data-id="element-218">
                "{testimonial.text}"
              </p>

              <div className="flex items-center gap-4 mt-auto pt-4 border-t border-sage-50" data-id="element-219">
                <div className="w-11 h-11 rounded-full bg-sage-100 text-sage flex items-center justify-center font-serif text-lg font-semibold shrink-0" data-id="element-220">
                  {testimonial.name.charAt(0)}
                </div>
                <div data-id="element-221">
                  <p className="font-serif font-medium text-charcoal-800" data-id="element-222">
                    {testimonial.name}
                  </p>
                  <p className="text-sm text-charcoal-500" data-id="element-223">
                    {testimonial.location}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}